import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User, Logueo } from '../models/user';
import { ParameterConst } from 'src/app/util/constant';
import { environment } from 'src/environments/environment'; 
import { AlertaService } from 'src/app/util/alerta.service';
import { MsjDialogService } from 'src/app/service/msjDialogService';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { UserService } from '../service/user.service';
import { DataService } from '../common/data.service';
import { Filter } from '../models/filter';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  hide = true;
  filtroForm: FormGroup;
  dataSource: MatTableDataSource<User>;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = ['sqUsuario','nombreCompleto', 'correo', 'estado'/*, 'archivo', 'img', 'estado', 'accion'*/];
  arrTematicas;
  selected;

  constructor(private route: ActivatedRoute,
    private alertaService: AlertaService,private router: Router,
    private msjSnackBar : MsjDialogService, private userService: UserService,
    private dataService : DataService) {
      
  
   }

  ngOnInit(): void {
 
    this.setForm();
    this.loadInit();

  }

  loadInit(){
    let filter = new Filter();
    filter.nombre = "";
    this.cargaBandeja(filter);
  }

  setForm(){
    this.filtroForm = new FormGroup({
      nombre: new FormControl('')
    }) 
  }


  buscarUsuario(){

    let filter = new Filter();
    filter.nombre = this.filtroForm.value.nombre;
    this.cargaBandeja(filter);

  }

  cargaBandeja(filter:Filter){
    
    this.userService.obtenerUsuarios(filter).pipe().subscribe(lista => {
      this.dataSource = new MatTableDataSource(lista);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;     
    });

  }

  hasError(controlName: string) {
    return this.filtroForm.controls[controlName].invalid;
  }

  nuevoUsuario(){
    let usu =  new User();
    this.dataService.setEditUsu(usu);
    this.router.navigate(['/admin/form-user']);
  }

  cambiarEstado(user:User, estado: string){



  }

  editarUsuario(usu: User){
    this.dataService.setEditUsu(usu);
    this.router.navigate(['/admin/form-user']);
  }

}
